import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FileText, LogOut, Receipt, Repeat } from "lucide-react";
import { usePortalAuth } from "../../context/PortalAuthContext";
import "./portal.css";

export default function PortalShell({ children, title, subtitle }) {
  const navigate = useNavigate();
  const { customer, logout } = usePortalAuth();

  const handleLogout = () => {
    logout();
    navigate("/portal/login");
  };

  const displayName =
    customer?.displayName ||
    customer?.companyName ||
    customer?.customerName ||
    customer?.cust_ID ||
    "Customer";

  return (
    <div className="portal-page">
      <header className="portal-header">
        <div className="portal-header__inner">
          <div>
            <p className="portal-header__eyebrow">Billing portal</p>
            <h1>{title}</h1>
            {subtitle ? <p className="portal-header__sub">{subtitle}</p> : null}
          </div>
          <div className="portal-header__user">
            <span>{displayName}</span>
            <button type="button" onClick={handleLogout} className="portal-btn portal-btn--ghost">
              <LogOut size={16} />
              Sign out
            </button>
          </div>
        </div>
        <nav className="portal-nav">
          <NavLink
            to="/portal/invoices"
            className={({ isActive }) =>
              `portal-nav__link${isActive ? " active" : ""}`
            }
          >
            <FileText size={16} />
            Invoices
          </NavLink>
          <NavLink
            to="/portal/receipts"
            className={({ isActive }) =>
              `portal-nav__link${isActive ? " active" : ""}`
            }
          >
            <Receipt size={16} />
            Payment history
          </NavLink>
          <NavLink
            to="/portal/recurring"
            className={({ isActive }) =>
              `portal-nav__link${isActive ? " active" : ""}`
            }
          >
            <Repeat size={16} />
            Upcoming charges
          </NavLink>
        </nav>
      </header>
      <main className="portal-main">{children}</main>
    </div>
  );
}
